export type IllustrationDictionary =
  | "absenteeism"
  | "activity_feed"
  | "admin"
  | "appreciation"
  | "be_quick_dont_hurry"
  | "brand_promise"
  | "brand_vision"
  | "challenge_accepted"
  | "check_ins"
  | "comments"
  | "connections"
  | "custom_question"
  | "customer_success"
  | "enps_survey"
  | "feedback"
  | "goal_task"
  | "goals"
  | "growth"
  | "high_five"
  | "home"
  | "in_good_company"
  | "incentives"
  | "insights"
  | "integrations"
  | "know_your_audience"
  | "launch"
  | "management"
  | "messages"
  | "mobile"
  | "nominations_and_awards"
  | "okrs"
  | "peer_to_peer"
  | "performance_management"
  | "processing"
  | "productivity"
  | "pulse_survey"
  | "recognition"
  | "retention"
  | "rewards_catalog"
  | "rewards"
  | "security"
  | "skills"
  | "surveys"
  | "sync_ups"
  | "talent_review"
  | "team"
  | "yes_and";
